export const ButtonNav = ({text, link}) => {
    return (
        <a className="sw-btn sw-btn_nav" href={link}>
            <span>{text}</span>
        </a>
    );
};
